/**
 * profile-documents.js
 */

import React from 'react';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { objectToFormData } from 'utils/form-data';
import { UserContext } from 'contexts/user/user-context';
import Button from 'components/button';
import CategoryDocsEditor from 'components/category-docs-editor';
import DrawerContentBuilder from 'components/menu-drawer/drawer-content-builder';
import DrawerContent from 'components/menu-drawer/drawer-content';
import DrawerActionButton from 'components/menu-drawer/drawer-action-button';
import ConfirmUnsavedEditor from 'components/menu-drawer/confirm-unsaved-editor';
import MobileDrawerAppBar from 'components/menu-drawer/mobile/mobile-drawer-app-bar';


 
const UserDocuments = (props) => {
  const {
    user,
    setUser,
    drawerState,
    onClose
  } = props;
  const { user: currentUser, setUser: setCurrentUser } = React.useContext(UserContext);
  const { enqueueSnackbar } = useSnackbar();
  const [docFields, setDocFields] = React.useState();
  const [isDirty, setIsDirty] = React.useState(false);
  const title = 'Uploaded Documents';


  const onDocFieldsChanged = (docFields) => {
    setDocFields(docFields);
    setIsDirty(true);
  }


  const saveDocuments = async () => {
    drawerState.loading.content.set(true);

    const formData = objectToFormData(
      {
        documents: docFields.documents,
        fileDeletions: docFields.deletions.files,
        categoryDeletions: docFields.deletions.categories
      },
      '',
      ['category', 'url', 'localId']
    );

    const response = await axios.put(`account/${user.id}/documents`, formData);

    if (response.status === 200) {  
      const data = response.data;    
      setIsDirty(false);
      setUser(data);
      enqueueSnackbar('Documents Saved', { variant: 'success' });

      if (user.id === currentUser.id) {
        setCurrentUser(data);
      } 
    }

    drawerState.loading.content.set(false);
  }


  const cancelButton = (
    <Button upperCase={false} onClick={onClose}>Cancel</Button>
  );


  const saveButton = (
    <DrawerActionButton
      level={1}
      disabled={!isDirty}
      onClick={saveDocuments}
      style={{ marginLeft: 16 }}
      children='Save'
    />
  );


  return (
    <>
      <DrawerContentBuilder
        mobileAppBar={{ content: (
          <MobileDrawerAppBar
            title={title}
            saveButton={saveButton}
            onClose={onClose}
          />
        )}}
        desktopHeader={{
          title,
          actions: <>{cancelButton}{saveButton}</>
        }}
        stickyHeader
        children={(triggerElement, desktopHeader) => (
          <>
            {triggerElement}
            {desktopHeader}

            <DrawerContent overflowY="auto">
              <CategoryDocsEditor
                documents={user?.documents}
                setDocFields={onDocFieldsChanged}
              />
            </DrawerContent>
          </>
        )}
      />

      <ConfirmUnsavedEditor dirty={isDirty} save={saveDocuments} />
    </>
  );
}

 export default UserDocuments;